import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const TruckShowcase = () => {
  return (
    <section className="relative overflow-hidden bg-[#001E52] py-20 md:py-28" data-testid="truck-showcase-section">
      <div className="pointer-events-none absolute -right-40 top-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#FE6A04]/10 blur-3xl" />
      {/* abstract moving road line */}
      <svg className="absolute bottom-10 left-0 w-full h-10 opacity-40" preserveAspectRatio="none" viewBox="0 0 800 40">
        <line x1="0" y1="20" x2="800" y2="20" stroke="#FE6A04" strokeWidth="2" strokeDasharray="24 20">
          <animate attributeName="stroke-dashoffset" from="0" to="-88" dur="2.2s" repeatCount="indefinite" />
        </line>
      </svg>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-sm text-[#FE6A04] uppercase tracking-widest font-semibold">Capacity, On Demand</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            The right equipment for every lane.
          </h2>
          <p className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl mx-auto">
            Dry van, reefer, flatbed, expedited, air, and ocean freight coordination — we help source qualified capacity
            and match the right solution to your shipment, then coordinate pickup, transit, and delivery through a single
            point of contact.
          </p>
          <p className="mt-6 font-heading text-lg sm:text-xl font-semibold text-white">
            Connecting capacity. Consolidating freight. <span className="text-[#FE6A04]">Delivering reliability.</span>
          </p>
          <a
            href="#contact"
            data-testid="showcase-cta"
            className="mt-8 inline-flex items-center gap-2 px-8 py-4 bg-[#FE6A04] text-white font-semibold hover:bg-[#e15e02] transition-colors"
          >
            Request a Quote <ArrowRight size={18} />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
